import Vue from "vue"

const store = Vue.observable({
  searchTerm: "",
})

export const getters = {
  searchTerm: {
    get: () => store.searchTerm,
    set: (term) => (store.searchTerm = term),
  },
  searchTermParam: () => store.searchTerm.replace(" ", "-"),
}

export const actions = {
  reset: () => (store.searchTerm = ""),
}
